/**
 * Created by katarinababic on 27.6.24.
 */
import { makeAutoObservable } from 'mobx';
import { HttpBackend } from '../../Services/Http/HttpBackend';
import { v1ParamsToV3Params } from './exploreV3Params';
import { ExploreEntryQueryRequest } from './ExploreEntryQueryRequest';
import { Instructor, createInstructor } from './Instructor';
import { SubscribableEntryBase, createSubscribableEntryBase } from './SubscribableEntry';
import { Media, createMedia } from '../Media/Media';
import { WebinarFaqEntry, createWebinarFaqEntry } from './WebinarFaqEntry';

export type WebinarEntry = SubscribableEntryBase & {
  type: 'webinar';
  language: string;
  previewVideos: Media[];
  frequentlyAskedQuestions: WebinarFaqEntry[];
  getPreviewVideo(lang: string): Media | undefined;
};

export function createWebinarEntry(json?: Partial<WebinarEntry>): WebinarEntry {
  const base = createSubscribableEntryBase(json, 'webinar');
  return makeAutoObservable({
    ...base,
    hosts: (json?.hosts ?? []).map((h: any) => createInstructor(h)),
    language: json?.language ?? 'de',
    previewVideos: (json?.previewVideos ?? []).map((v: any) => createMedia(v)),
    frequentlyAskedQuestions: (json?.frequentlyAskedQuestions ?? []).map((f: any) => createWebinarFaqEntry(f)),

    getPreviewVideo(lang: string): Media | undefined {
      const languageVideo = this.previewVideos.find((a) => a.language?.toLowerCase() === lang.toLowerCase());
      const germanVideo = this.previewVideos.find((a) => a.language?.toLowerCase() === 'de');
      return languageVideo ?? germanVideo ?? this.previewVideos[0];
    },
  });
}

export const WebinarEntryApi = {
  find(request: Omit<ExploreEntryQueryRequest, 'type'>): Promise<WebinarEntry[]> {
    return HttpBackend.get(`/coach/explore/v3/entries`, v1ParamsToV3Params({ ...request, type: 'webinar' })).then((res) =>
      (res ?? []).map((r: any) => createWebinarEntry(r)),
    );
  },

  findOne(id: string): Promise<WebinarEntry> {
    return HttpBackend.get(`/coach/explore/v3/entries/${id}`).then((res) => createWebinarEntry(res));
  },
};
